export default {
  name: 'GridFilterOptions',
  props: {
    dataObj: { 
      /* 
      { gridOptions:
                    { bAutoExpand: true, bPagination: true, bGroupPanel: false, bColumnReordering: false, bColumnFixing: false, autoClose: false },
         gridOptionsChanged: Func,
         refreshRecords: Func
      }
      */
      type: Object,
      required: true
    },
    localStorageName: { //if not present no local storage ability
      type: String,
      default: null
    }
  },
  data: function () {
    return {
      optionsExpanded: false,
      autoClose: false,
    }
  },
  created() {
    this.getFilterFromLocal();
  },
  methods: {
    isRaised(item) {
      if (item == true)
        return "background-light-gray";
      else
        return 'background-white';
    },
    gridActions(item) {
      if (item == "autoExpand") {
        this.dataObj.gridOptions.autoExpand = !this.dataObj.gridOptions.autoExpand;
      }
      else if (item == "pagination") {
        this.dataObj.gridOptions.pagination = !this.dataObj.gridOptions.pagination;
      }
      else if (item == "groupPanel") {
        this.dataObj.gridOptions.groupPanel = !this.dataObj.gridOptions.groupPanel;
      }
      else if (item == "columnReordering") {
        this.dataObj.gridOptions.columnReordering = !this.dataObj.gridOptions.columnReordering;
      }
      else if (item == "columnFixing") {
        this.dataObj.gridOptions.columnFixing = !this.dataObj.gridOptions.columnFixing;
      }
      else if (item == "autoClose") {
        this.dataObj.gridOptions.autoClose = !this.dataObj.gridOptions.autoClose;
        this.optionsExpanded = false;
      }

      if (this.localStorageName)
        this.saveFilterToLocal();

      this.dataObj.gridOptionsChanged(this.dataObj.gridOptions);

      if (this.dataObj.gridOptions.autoClose)
        this.optionsExpanded = false;
    },
    getFilterFromLocal() {
      if (!this.localStorageName)
        return;

      let gridOpt = this.$localStorage.get(this.localStorageName);
      if (gridOpt) {
        try { this.dataObj.gridOptions = JSON.parse(gridOpt); }
        catch (err) {
          console.log("err", err)
          this.dataObj.gridOptions = {
            autoExpand: true,
            pagination: true,
            groupPanel: true,
            columnReordering: true,
            autoClose: false
          };
        };
      }     
    },
    saveFilterToLocal() {
      if (!this.localStorageName)
        return;

      this.$localStorage.set(this.localStorageName, JSON.stringify(this.dataObj.gridOptions));
    },
  },
  }


